import { type ComponentType, lazy, Suspense, useEffect } from 'react';
import { BREAKPOINTS_WIDTHS, useWindowSize } from '@belong/common';
import { Modal } from '@belong/ui';
import { ANALYTICS_MODAL_NAMES } from 'analytics';
import clsx from 'clsx';
import { TOUR_MODAL_HEIGHT } from './town-tour/town-tour.constants';

type TourProps = { onHide: () => void };

function TourLoadFailed({ onHide }: TourProps) {
  useEffect(onHide, [onHide]);
  return null;
}

const TownTourModal = lazy<ComponentType<TourProps>>(() =>
  import('./town-tour/town-tour-modal')
    .then((mod) => ({ default: mod.TownTourModal }))
    .catch(() => ({ default: TourLoadFailed })),
);

type HowItWorksModalProps = {
  show: boolean | string;
  onHide: () => void;
};

export function HowItWorksModal({ show, onHide }: HowItWorksModalProps) {
  const { width } = useWindowSize();
  const isMobile = width < BREAKPOINTS_WIDTHS.MD;

  return (
    <Modal
      name={ANALYTICS_MODAL_NAMES.HOW_IT_WORKS}
      isOpen={Boolean(show)}
      onDismiss={onHide}
      size={isMobile ? 'fullScreen' : 'auto'}
      overlayClassName="z-fullscreen"
      contentClassName="md:w-11/12 lg:w-large-modal-lg"
    >
      <Suspense
        fallback={
          <div
            className={clsx('h-[100dvh] bg-white md:h-auto', TOUR_MODAL_HEIGHT)}
          />
        }
      >
        <TownTourModal onHide={onHide} />
      </Suspense>
    </Modal>
  );
}
